import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const projectsPlugin = createPlugin({
  id: 'projects',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindProjectsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(projectsPlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidenceProjectsPage = projectsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceProjectsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-projects", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
